// Unicode regex pattern sources, defined as regex literals so that
// @babel/plugin-transform-unicode-property-regex can transpile them for older browsers.
// Sharing these constants ensures each character class is expanded only once in the bundle.
//
// In native JS: /\p{L}/u.source = "\p{L}" (no brackets)
// After Babel:  /\p{L}/u.source = "[A-Za-z\xAA...]" (wrapped in brackets)
// getInner strips brackets when present, so the result can be embedded in [${letter}].
//
// The `u` flag must be kept through the build (see babelLegacyConfig.js): it lets
// Babel emit a single `[...]` class. Dropping it makes Babel rewrite `\p{L}` into a
// surrogate-pair `(?:...|...)` alternation, which is not a valid character-class
// fragment and would break every consumer that embeds these in `[...]`.

function getInner(regex) {
  const source = regex.source;
  if (source.startsWith("[") && !source.startsWith("[^")) {
    return source.slice(1, -1);
  }
  return source;
}

/** Inner content for Unicode letters — use as [${letter}] or in [${letter}${mark}] */
export const letter = getInner(/\p{L}/u);

/** Inner content for Unicode combining marks — use as [${mark}] */
export const mark = getInner(/\p{M}/u);

/** Complete character class pattern for CJK/Thai script detection */
export const cjkThai =
  /[\p{Script=Han}\p{Script=Hiragana}\p{Script=Katakana}\p{Script=Thai}]/u
    .source;

/** Complete negated character class for non-letter matching */
export const notLetter = "[^" + letter + "]";
